import _ from "lodash";
// import InputMask from "react-input-mask";
import { useRef } from "react";
import { IMaskInput } from "react-imask";

export type Props = {
  value?: string;
  onChange?: (value: string) => any;
  disabled?: boolean;
  isError: boolean;
};

function ExpiryInput(props: Props) {
  const { value = ``, onChange = () => {}, disabled = false, isError } = props;

  const inputRef = useRef();

  return (
    <div className={`w-full relative`}>
      <IMaskInput
        name="expiry"
        id="expiry"
        autoFocus={false}
        inputMode="numeric"
        placeholder="Expiry (ie. 01/27)"
        value={_.toString(value).replace(/\D/g,'')}
        disabled={disabled}
        className={`w-full text-center flex items-center justify-center rounded-md outline-0`}
        style={{
          fontFamily: "Roboto, sans-serif",
          fontWeight: 700,
          fontSize: `20px`,
          lineHeight: `24px`,
          height: `50px`,
          borderWidth: `1px`,
          borderColor: isError ? `red` : `#E7EAF7`,
          color: `#0E2A48`,
        }}

        mask={`00/00`}
        radix="_"
        unmask={true} // true|false|'typed'
        // ref={ref}
        // inputRef={inputRef}  // access to nested input
        // DO NOT USE onChange TO HANDLE CHANGES!
        // USE onAccept INSTEAD
        onAccept={
          // depending on prop above first argument is
          // `value` if `unmask=false`,
          // `unmaskedValue` if `unmask=true`,
          // `typedValue` if `unmask='typed'`
          (value, mask) => {
            const newValue = _.toString(value).replace(/\D/g,'');
          
          onChange(newValue);
        }}
        prepare={(rawValue) => {
          const str = _.toString(rawValue);
          const numberStr = str.replace(/[^\d.-]+/g, '');

          if (numberStr.length === 6 && numberStr.slice(2,4) === '20') {
            return `${numberStr.slice(0,2)}/${numberStr.slice(4,6)}`;
          }

          return rawValue;
        }}
      />
    </div>
  );

  // return (
  //   <div className={`w-full relative`}>
  //     <InputMask 
  //       name="expiry"
  //       id="expiry"
  //       // inputRef={ref => {
  //       //   if (ref) {
  //       //     setTimeout(() => {
  //       //       ref.focus();
  //       //     }, 500);
  //       //   }
  //       // }}
  //       // autoComplete="off"
  //       autoFocus={false}
  //       mask="99/99"
  //       inputMode="numeric"
  //       maskChar="_"
  //       placeholder="Enter Expiry (ie. 01/27)"
  //       onChange={(event) => {
  //         const newValue = _.toString(event.target.value).replace(/\D/g,'');
          
  //         onChange(newValue);
  //       }}
  //       value={_.toString(value).replace(/\D/g,'')}
  //       disabled={disabled}
  //       // autoFocus={autoFocus}
  //       className={`w-full text-center flex items-center justify-center rounded-md outline-0`}
  //       style={{
  //         fontFamily: "Roboto, sans-serif",
  //         fontWeight: 700,
  //         fontSize: `20px`,
  //         lineHeight: `24px`,
  //         height: `50px`,
  //         borderWidth: `1px`,
  //         borderColor: isError ? `red` : `#E7EAF7`,
  //         color: `#0E2A48`,
  //       }}
  //     />
  //   </div>
  // );
}

export { ExpiryInput };